<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="人员管理">
      <template>
        <el-button
          icon="el-icon-plus"
          size="small"
          type="primary"
          @click="newlyAdded"
          >新增人员</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 0
                  ? 'iconfont icon-lock'
                  : 'iconfont icon-jihuo'
              "
            ></i
            >{{ row.row.status == 0 ? "锁定" : "激活" }}
          </div>

          <template v-if="!isTakeoutRole(row.row)">
            <div class="button button_revoke" @click="systemPermissions(row.row)">
              <i class="iconfont icon-authority"></i> 系统权限
            </div>

            <div
              class="button button_revoke"
              @click="fundAccountPermissions(row.row)"
            >
              <i class="iconfont icon-authority"></i> 资金权限
            </div>
          </template>

          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <el-dialog
      title="资金权限"
      :visible.sync="dialogVisible"
      width="1200px"
      @close="dialogBeforeClose"
    >
      <div class="table">
        <el-table :data="accountList">
          <el-table-column prop="account_name" label="资金账户">
          </el-table-column>
          <el-table-column label="权限设置" prop="type">
            <template slot-scope="scope">
              <el-checkbox-group v-model="scope.row.type">
                <el-checkbox label="0">查看</el-checkbox>
                <el-checkbox label="1">收款</el-checkbox>
                <el-checkbox label="2">付款</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose">取 消</el-button>
        <el-button type="primary" @click="savePermissions">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="系统权限"
      :visible.sync="systemPermissionDialogVisible"
      width="1200px"
      @close="systemPermissionClose"
    >
      <div class="table">
        <el-table :data="storeList" border>
          <el-table-column
            v-for="store in storeList[0]"
            :key="store.shop_id"
            :label="store.name"
            prop="store.shop_id"
          >
            <template v-slot="scope">
              <el-tree
                :data="getProcessedPermissionTree(store.shop_id)"
                show-checkbox
                node-key="nodeKey"
                ref="tree"
                highlight-current
                :props="defaultProps"
                @check-change="
                  (data, checked) => handleNodeClick(data, checked, store)
                "
                :default-checked-keys="getDefaultCheckedKeys(store)"
              >
              </el-tree>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="systemPermissionClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  userGetlist,
  userLock,
  userDel,
  userActive,
  getshoplist,
  permissionGetlist,
  userFinancePermissionGet,
  companyAccountGetList,
  userFinancePermissionSet,
  getUserShoplist,
  userPermissionGetlist,
  userPermissionSetlist,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getRoles } from "@/utils";
import { ROLE_IDS } from "@/constants/roles";
export default {
  name: "personnelManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 450,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "姓名/电话",
            type: "input",
            key: "keywords",
          },
          {
            label: "角色",
            type: "select",
            key: "role_id",
            options: [
              {
                label: "老板",
                value: 3,
              },
              {
                label: "员工",
                value: 4,
              },
              {
                label: "三方运营",
                value: ROLE_IDS.TAKEOUT_UNIT,
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "启用",
                value: 1,
              },
              {
                label: "禁用",
                value: 2,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
          },
          {
            label: "商户",
            prop: "comp_name",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "电话",
            prop: "tel",
          },
          {
            label: "角色",
            prop: "role_name",
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
          {
            label: "主门店",
            prop: "main_shop_name",
          },
          {
            label: "关联门店",
            prop: "link_shop_name",
          },
          {
            label: "更新时间",
            prop: "update_time",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      dialogVisible: false,
      accountList: [],
      currentUserId: "",

      storeList: [],
      defaultProps: {
        children: "sub_list",
        label: "name",
      },
      systemPermissionDialogVisible: false,
      permissionTree: [],
      userPermissionOLDMap: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    // 初始化列表内容
    this.getlist();
    this.getTree();
    this.getData();
  },
  methods: {
    getData() {
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    processOldPermission(list) {
      // 已有权限先复制一份到新权限表，再增删改
      this.userPermissionNew = list.map((item) => {
        return { ...item };
      });

      // 根据已有权限表做默认选中操作
      // 创建一个 Map 对象来存储结果
      let shopPermissionsMap = new Map();
      // 遍历数据，并将 permission_id 添加到对应的 shop_id 键下
      list.forEach((item) => {
        // 如果 Map 中已有该 shop_id，就将 permission_id 添加到它的数组中
        if (shopPermissionsMap.has(item.shop_id)) {
          let permissions = shopPermissionsMap.get(item.shop_id);
          permissions.push(item.permission_id);
          shopPermissionsMap.set(item.shop_id, permissions);
        } else {
          // 如果没有，就创建一个新的数组，只包含当前的 permission_id
          shopPermissionsMap.set(item.shop_id, [item.permission_id]);
        }
      });
      this.userPermissionOLDMap = shopPermissionsMap;
    },

    getProcessedPermissionTree(shopId) {
      let processNode = (node, shopId) => {
        const newNode = { ...node };
        newNode.nodeKey = `${shopId}-${node.id}`;
        // 递归处理每个子节点
        if (newNode.sub_list) {
          newNode.sub_list = newNode.sub_list.map((childNode) =>
            processNode(childNode, shopId)
          );
        }
        return newNode;
      };
      // 处理顶级节点
      return this.permissionTree.map((node) => processNode(node, shopId));
    },

    // 默认选中
    getDefaultCheckedKeys(row) {
      let shopId = row.shop_id;
      let permission_ids = this.userPermissionOLDMap.has(shopId)
        ? this.userPermissionOLDMap.get(shopId)
        : [];
      const newList = permission_ids.map((item) => {
        return `${shopId}-${item}`;
      });
      return newList;
    },

    handleSubmit() {
      let submitData = [];
      this.$refs.tree.forEach((item) => {
        // console.log(item);
        let leafNodes = item.getCheckedNodes(true);
        leafNodes.forEach((it) => {
          let parts = it.nodeKey.split("-");
          submitData.push({
            shop_id: parseInt(parts[0]),
            permission_id: parseInt(parts[1]),
          });
        });
      });
      this.setUserPermissionList({
        user_id: this.currentUserId,
        comp_id: this.compId,
        list: submitData,
      }).then(() => {
        this.$message.success("操作成功");
        this.systemPermissionDialogVisible = false;
      });
    },
    handleNodeClick(data, checked, store) {
      let permission_id = data.id;
      let shop_id = store.shop_id;
      if (checked) {
        // 检查数组中是否已经存在相同的权限对象
        const existingPermission = this.userPermissionNew.find(
          (p) => p.permission_id === permission_id && p.shop_id === shop_id
        );

        // 如果找不到匹配的权限对象，则添加新的权限对象
        if (!existingPermission) {
          this.userPermissionNew.push({
            permission_id: permission_id,
            shop_id: shop_id,
          });
        } else {
          // 查找匹配项的索引
          const index = this.userPermissionNew.findIndex(
            (p) => p.permission_id === permission_id && p.shop_id === shop_id
          );

          // 如果找到了匹配的权限对象，从数组中删除它
          if (index !== -1) {
            this.userPermissionNew.splice(index, 1);
          }
        }
      }
    },
    fetchData(pickUserId) {
      if (pickUserId) {
        Promise.all([
          this.getUserPermissionList(pickUserId),
          this.getStoreList(pickUserId),
        ])
          .then((res) => {
            console.log(
              "%c [ res ]-378",
              "font-size:13px; background:pink; color:#bf2c9f;",
              res
            );
            this.userPermission = res[0];
            this.storeList = [res[1]];

            this.userPermissionOLD = res[0];
            this.processOldPermission(res[0]);
          })
          .catch((error) => {
            console.error("An error occurred:", error);
          });
      }
    },
    getTree() {
      return permissionGetlist().then((res) => {
        if (res.code == 1) {
          this.permissionTree = res.data;
          console.log(
            "%c [  ]-33",
            "font-size:13px; background:pink; color:#bf2c9f;",
            res
          );
        }
      });
    },
    getStoreList(pickUserId) {
      // 是找用设计权限的用户拥有的店铺，所以是 pickUserId, 没有的话需要先输入关键字，搜一遍用户并选中
      // let data = JSON.parse(getRoles());
      return getUserShoplist({
        comp_id: JSON.parse(getRoles()).comp_id,
        user_id: pickUserId,
      }).then((res) => {
        if (res.code == 1) {
          return res.data;
        }
      });
    },
    getUserPermissionList(pickUserId) {
      // 同上，是找用设计权限的用户拥有的店铺，所以是 pickUserId, 没有的话需要先输入关键字，搜一遍用户并选中
      // let data = JSON.parse(getRoles());
      return userPermissionGetlist({
        comp_id: JSON.parse(getRoles()).comp_id,
        user_id: pickUserId,
      }).then((res) => {
        if (res.code == 1) {
          return res.data;
        }
      });
    },
    setUserPermissionList(json) {
      return userPermissionSetlist(json).then((res) => {
        if (res.code == 1) {
          return res.data;
        }
      });
    },
    systemPermissionClose() {
      this.systemPermissionDialogVisible = false;
    },
    systemPermissions(row) {
      this.systemPermissionDialogVisible = true;
      this.currentUserId = row.id;
      this.fetchData(row.id);
    },
    savePermissions() {
      let obj = {
        user_id: this.currentUserId,
        comp_id: this.compId, // JSON.parse(getRoles()).comp_id,
        list: this.accountList.map((item) => {
          return {
            account_id: item.id,
            type: item.type.join(","),
          };
        }),
      };
      userFinancePermissionSet(obj).then((res) => {
        if (res.code == 1) {
          this.$message.success("设置成功");
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    fundAccountPermissions(row) {
      this.dialogVisible = true;
      this.currentUserId = row.id;
      this.obtainFundsAccount(row.comp_id, row.id);
    },
    isTakeoutRole(userRow) {
      return Number(userRow.role_id) === ROLE_IDS.TAKEOUT_UNIT;
    },
    // 获取员工所在商户的资金账户
    obtainFundsAccount(id, userId) {
      companyAccountGetList({ comp_id: id, limit: 10000, status: 0 }).then(
        (res) => {
          if (res.code == 1) {
            this.accountList = res.data.map((item) => {
              item.type = [];
              return item;
            });
            userFinancePermissionGet({ comp_id: id, user_id: userId }).then(
              (result) => {
                this.accountList.map((item) => {
                  const obj = result.data[0].list.find(
                    (list) => list.account_id == item.id
                  );

                  if (obj) {
                    item.type = obj.type.split(",");
                  }
                  return item;
                });
              }
            );
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    dialogBeforeClose() {
      this.dialogVisible = false;
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      this.basicListconfig.searchParameters.is_showAll = 1;
      userGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取门店列表
    obtainDataSource() {
      getshoplist({ limit: 10000, status: 0, comp_id: this.compId }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/personnelManagement/index.vue